import { Voter } from "@activecollab/security";
import { isFinancialManager, isOwner, isPowerUser } from "~/utils/userHelper";

export class CompanyVoter extends Voter {
  attributes = ["edit", "create_invoice", "archive", "delete", "archiveOrDelete"];

  supports(attribute, subject) {
    if (!this.attributes.includes(attribute)) {
      return false;
    }
    return subject.class === "Company";
  }

  voteOnAttribute(attribute, subject, user) {
    const canEdit = isPowerUser(user) || isFinancialManager(user);
    const canManage = () => {
      if (subject.is_owner) return false;
      if (user.company_id === subject.id) return false;
      return canEdit;
    };

    const canArhiveOrTrash = () => {
      if (subject.is_owner) return false;

      if (isOwner(user) && user.company_id !== subject.id) {
        return true;
      }

      if (canEdit && user.company_id !== subject.id) {
        if (!subject?.members) return true;

        if (subject.members.some((member) => isOwner(member) || !!member?.has_custom_permissions)) {
          return false;
        }

        return true;
      }

      return false;
    };

    switch (attribute) {
      case "edit":
        return canEdit;
      case "archive":
        return canManage();
      case "delete": {
        if (subject.has_documents) return false;
        return canManage();
      }
      case "archiveOrDelete": {
        return canArhiveOrTrash();
      }

      case "create_invoice": {
        if (!this.state.config_options.get("invoices_enabled")) {
          return false;
        }

        return isOwner(user) || isFinancialManager(user);
      }
    }
    throw new Error("This code should not be reached!");
  }
}
